// src/com/tsr/TransPlanTsrEditDetail.js
import React, { useEffect, useState } from 'react';
//import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Grid2 } from '@mui/material';
//import { AppWord, AppObject, AppStyle } from '../../value/AppConst';
import IsValid from '../../value/IsValid';
import { AppWord } from '../../value/AppConst';
import ValueMisc from '../../value/ValueMisc';
import VzmTextField from '../../common/VzmTextField';
import VzmIntField from '../../common/VzmIntField';
import Datetime24Picker from '../../common/Datetime24Picker';

function nullableBol(value) {
    return !Boolean(value) || /^\d{5,20}$/.test(value);
}

function nullableSealNo(value) {
    return !Boolean(value) || /^[A-Z0-9]{5,20}$/.test(value);
}

const DataDict = {
    bol1: {id: 'bol1', label:'BOL.1', check: nullableBol}, // BOL1 00119817021433754
    bol2: {id: 'bol2', label:'BOL.2', check: nullableBol}, // BOL2
    bol3: {id: 'bol3', label:'BOL.3', check: nullableBol}, // BOL3
    loadCount: {id: 'loadCount', label:'상차수량', min:0, max:999999, check: (value) => value >= 0 && value <= 999999}, // 상차수량
    loadStTime: {id: 'loadStTime', label:'상차시작', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 상차시작
    loadEnTime: {id: 'loadEnTime', label:'상차종료', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 상차종료
    prosDptrTime: {id: 'prosDptrTime', label:'출발예정', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 출발예정
    prosArrTime: {id: 'prosArrTime', label:'도착예정', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 도착예정
    sealNo1: {id: 'sealNo1', label:'봉인번호.1', check: nullableSealNo}, // Seal1
    sealNo2: {id: 'sealNo2', label:'봉인번호.2', check: nullableSealNo}, // Seal2
    sealNo3: {id: 'sealNo3', label:'봉인번호.3', check: nullableSealNo}, // Seal3
    loadStaffName: {id: 'loadStaffName', label:'상차작업자', check: (value) => !Boolean(value) || value.length <= 10}, // 상차작업자
    unsoldBol: {id: 'unsoldBol', label: '전일미출고 BOL', check: nullableBol}, // 전일미출고 BOL
    unsoldPallet: {id: 'unsoldPallet', min:0, max:999999, label: 'Pallet', check: (value) => value >= 0 && value <= 999999}, // 전일미출고 Pallet
    unsoldCount: {id: 'unsoldCount', min:0, max:999999, label: '수량', check: (value) => value >= 0 && value <= 999999}, // 전일미출고 수량
    memo: {id: 'memo', label:'특이사항', check: (value) => !Boolean(value) || value.length <= 100}, // 특이사항
}

/**
 * 상차 상세내역.
 * @param {*} param0 
 * @returns 
 */
export default function TransPlanTsrEditDetail({
    item,
    onChangeValue
}) {
    const [threeDays, setThreeDays] = useState({yesterday: null, tomorrow: null, today: ValueMisc.getYMD()});

    useEffect(()=>{
        if(item) {
            const today = item.planDate;
            const dateToday = ValueMisc.getDateFromYmd(today);
            const yesterday = ValueMisc.getYMD(ValueMisc.addDays(dateToday, -1));
            const tomorrow = ValueMisc.getYMD(ValueMisc.addDays(dateToday, 1));
            setThreeDays({yesterday, tomorrow, today});
        }
    }, [item]);

    return(
        <Box style={{paddingTop: '0.3rem'}}>
            <Grid2 container spacing={1.5}>
                <Grid2 size={12}>
                            <VzmTextField
                                dict={DataDict.bol1} value={item.bol1}
                                onChange={onChangeValue} fullWidth={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <VzmTextField
                                dict={DataDict.bol2} value={item.bol2}
                                onChange={onChangeValue} fullWidth={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <VzmTextField
                                dict={DataDict.bol3} value={item.bol3}
                                onChange={onChangeValue} fullWidth={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <VzmIntField
                                dict={DataDict.loadCount} value={item.loadCount}
                                onChange={onChangeValue} fullWidth={true}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <VzmTextField
                                dict={DataDict.loadStaffName} value={item.loadStaffName}
                                onChange={onChangeValue} fullWidth={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <Datetime24Picker
                                dict={DataDict.loadStTime} value={item.loadStTime}
                                onChange={onChangeValue}
                                minDate={threeDays.yesterday}
                                maxDate={threeDays.tomorrow}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <Datetime24Picker
                                dict={DataDict.loadEnTime} value={item.loadEnTime}
                                onChange={onChangeValue}
                                minDate={threeDays.yesterday}
                                maxDate={threeDays.tomorrow}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <Datetime24Picker
                                dict={DataDict.prosDptrTime} value={item.prosDptrTime}
                                onChange={onChangeValue}
                                minDate={threeDays.yesterday}
                                maxDate={threeDays.tomorrow}
                            />
                </Grid2>
                <Grid2 size={6}>
                            <Datetime24Picker
                                dict={DataDict.prosArrTime} value={item.prosArrTime}
                                onChange={onChangeValue}
                                minDate={threeDays.yesterday}
                                maxDate={threeDays.tomorrow}
                            />
                </Grid2>
                <Grid2 size={4}>
                            <VzmTextField
                                dict={DataDict.sealNo1} value={item.sealNo1}
                                onChange={onChangeValue} fullWidth={true}
                                toUpperCase={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={4}>
                            <VzmTextField
                                dict={DataDict.sealNo2} value={item.sealNo2}
                                onChange={onChangeValue} fullWidth={true}
                                toUpperCase={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={4}>
                            <VzmTextField
                                dict={DataDict.sealNo3} value={item.sealNo3}
                                onChange={onChangeValue} fullWidth={true}
                                toUpperCase={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
                <Grid2 size={6}>
                                <VzmTextField
                                    dict={DataDict.unsoldBol} value={item.unsoldBol}
                                    onChange={onChangeValue} fullWidth={true}
                                    size={AppWord.SMALL}
                                />
                </Grid2>
                <Grid2 size={3}>
                                <VzmIntField
                                    dict={DataDict.unsoldPallet} value={item.unsoldPallet}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                </Grid2>
                <Grid2 size={3}>
                                <VzmIntField
                                    dict={DataDict.unsoldCount} value={item.unsoldCount}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                </Grid2>
                <Grid2 size={12}>
                            <VzmTextField
                                dict={DataDict.memo} value={item.memo}
                                onChange={onChangeValue} fullWidth={true}
                                size={AppWord.SMALL}
                            />
                </Grid2>
            </Grid2>
        </Box>
    );
}